import { useEffect } from "react";
import { toast } from "react-toastify";

// Some saves (an Undo that brings a record back) reload the page to show
// it. The reload used to land at the top with no word of what happened
// (CMS review round 2, georges-31): keep the place and the message.
const KEY = "safrati.afterReload";
const here = () => `${window.location.pathname}${window.location.search}`;

/** Reload this page, then come back to the same place and say `message`. */
export function reloadKeepingPlace(message) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ path: here(), y: window.scrollY, message }));
  } catch {
    // private window: the reload still happens
  }
  window.location.reload();
}

/** On the page after such a reload: the message, then the old scroll place once the page is tall enough. */
export function useAfterReload() {
  useEffect(() => {
    let saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(KEY) || "null");
      sessionStorage.removeItem(KEY);
    } catch {
      saved = null;
    }
    if (!saved || saved.path !== here()) return undefined;
    if (saved.message) toast.success(saved.message, { toastId: "after-reload" });
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (document.documentElement.scrollHeight >= saved.y + window.innerHeight || tries > 24) {
        window.scrollTo(0, saved.y);
        clearInterval(timer);
      }
    }, 250);
    return () => clearInterval(timer);
  }, []);
}
